"use strict";
// HTTP contract between a generated app's Worker (app half) and studio (host half).
//
//   browser ──▶ site Worker /api/dunea/<plugin>/*  ──(x-dunea-app-token)──▶ studio /api/plugins/<plugin>/*
//
// The browser never talks to studio directly and never holds the app token.
// The site Worker forwards requests with its per-app token (DUNEA_APP_TOKEN,
// injected at deploy and into the preview pod), which identifies the
// deployment and the environment (preview | production). Studio decides the
// payment mode from that, never from the request body.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_API = exports.APP_TOKEN_HEADER = void 0;
exports.APP_TOKEN_HEADER = 'x-dunea-app-token';
/** Path prefixes. Site Worker: `/api/dunea/<plugin>`. Studio: `/api/plugins/<plugin>`. */
exports.PLUGIN_API = {
    sitePrefix: (plugin) => `/api/dunea/${plugin}`,
    studioPrefix: (plugin) => `/api/plugins/${plugin}`,
};
